import { defineExperiment } from '@cian/experiments/ab';
import { NEW_MAIN_PAGE_EXPERIMENT } from './experiments';

export const BxMobileBx687NewMainpageExperiment = defineExperiment(NEW_MAIN_PAGE_EXPERIMENT, {
  default: 'A',
  groups: ['A', 'B'] as const,
});
